import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import appleStore from "../../Assets/Images/appleStore.svg";
import googlePlay from "../../Assets/Images/googlePlay.svg";
import facebook from "../../Assets/Images/003-facebook.svg";
import instagram from "../../Assets/Images/instagram.svg";
import logo from "../../Assets/Images/watermark_logo.svg";
import copyright from "../../Assets/Images/copyright.svg";
import "../../Assets/Styles/pages/footer.scss";
import LazyLoad from "react-lazyload";

const Footer: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const history = useHistory();

  const handlePage = (page: string) => {
    history.push(page);
  };

  if (location.pathname === "/edit") {
    return null;
  } else {
    return (
      <Row className="footer m-0 d-flex landing_header d-flex align-items-start ">
        <Row className="mt-lg-5 mt-3 pt-2 m-0 p-0 d-flex  align-items-start">
          <Col
            xs={12}
            lg={4}
            className="d-flex flex-column align-items-lg-start align-items-center  p-0"
          >
            <Row
              onClick={() => handlePage("/")}
              className="d-flex flex-column flex-lg-row pointer productSansBold text-white text_22 justify-content-center align-items-center m-0 ms-xl-2  p-0"
            >
              <Col className="d-flex justify-content-center">
                <img src={logo} className="logo" alt="logo" />
              </Col>
              <Col className="logo_text m-0 p-0"> {t("lang.ezywatermark")}</Col>
            </Row>
            <Row className="d-flex productSansLight  px-5 px-lg-0 text_14 centered">
              <Col className="text-white m-0 mt-2 ps-5 text-center text-lg-start ps-lg-4 ms-xl-2  pe-5 pe-lg-0  p-0">
                {t("Footer.Discription")}
              </Col>
            </Row>
            <Row className="d-flex productSansLight mt-3 mt-lg-2 mb-5 mb-lg-0 text_14 centered">
              <Col className="">
                <a
                  href="https://www.facebook.com/ezywatermark/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyLoad height={400} once>
                    <img alt="facebook" className="ps-4 p-0" src={facebook} />
                  </LazyLoad>
                </a>
              </Col>
              <Col>
                <a
                  href="https://www.instagram.com/ezy_watermark/?igshid=152p322uqciym"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyLoad height={400} once>
                    <img alt="instagram" className="" src={instagram} />
                  </LazyLoad>
                </a>
              </Col>
            </Row>
          </Col>
          <Col
            xs={12}
            lg={4}
            className="d-flex flex-column mb-5 mb-lg-0  align-items-lg-center align-items-center "
          >
            <Col className="align-items-lg-start align-items-center text-center d-flex flex-column productSans text_15 nav_D_text">
              <Row className="nav_text productSansBold text_22 line_height_100pc m-0 mb-2 pb-1 p-0">
                {" "}
                {t("Footer.Navigation")}
              </Row>
              <Row
                onClick={() => handlePage("/")}
                className=" pointer productSansLight text_15 m-0 p-0"
              >
                {" "}
                {t("header.Home")}
              </Row>
              <Row
                onClick={() => handlePage("/features")}
                className=" pointer productSansLight text_15 m-0 mt-3 p-0"
              >
                {" "}
                {t("Features")}
              </Row>
              <Row
                onClick={() => handlePage("/pricing")}
                className=" pointer productSansLight text_15 m-0 mt-3 p-0"
              >
                {" "}
                {t("Pricing")}
              </Row>
              <Row
                onClick={() =>
                  // (window.location.href = `${process.env.REACT_APP_GHOST_API_URL}`)
                  handlePage("/blogs")
                }
                className=" pointer productSansLight text_15 m-0 mt-3 p-0"
              >
                {" "}
                {t("Blogs")}
              </Row>
            </Col>
          </Col>
          <Col
            xs={12}
            lg
            className="d-flex flex-column align-items-lg-end align-items-center p-0"
          >
            <Col className="align-items-lg-start align-items-center text-center d-flex flex-column Aktiv text_15 nav_D_text">
              <Row className="nav_text productSansBold text_22 line_height_100pc m-0 mb-2 p-0">
                {" "}
                {t("Footer.ContactUs")}
              </Row>
              <Row className="footerTermsLinks productSansLight text_15 m-0 mb-5 mb-lg-0 p-0">
                <a className="m-0 p-0" href={`mailto:${t("Footer.Email")}`}>
                  {t("Footer.Email")}
                </a>
              </Row>
              <Row className="logo_text text_22 productSansBold m-0 mb-1 mt-2 p-0">
                {" "}
                {t("Footer.DownloadApp")}
              </Row>
              <Row className="app_text text_16 PoppinsLight m-0 mt-2 pt-1 p-0">
                <div className="d-flex flex-column flex-lg-row w-100 p-0 justify-content-center align-items-center">
                  <div className="d-flex justify-content-start">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.whizpool.ezywatermarklite"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LazyLoad height={400} once>
                        <img
                          alt="playstore"
                          className=" me-lg-2 size_112"
                          src={googlePlay}
                        />
                      </LazyLoad>
                    </a>
                  </div>
                  <div className="d-flex justify-content-center">
                    <a
                      href="https://apps.apple.com/us/app/ezy-watermark-photos-lite/id494473910"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LazyLoad height={400} once>
                        <img
                          alt="appstore"
                          className="ms-lg-1 mt-2 mt-lg-0 mb-5 mb-lg-0  size_112"
                          src={appleStore}
                        />
                      </LazyLoad>
                    </a>
                  </div>
                </div>
              </Row>
            </Col>
          </Col>
        </Row>
        <div className="w-100 m-0 p-0 productSansLight text_14 footerBorder footerTerms px-4 py-2 mt-4 d-flex flex-lg-row flex-column align-items-center justify-content-center">
          <div>
            {/* <span className="mx-2 text_22 line_height_100pc pt-1">{"©"}</span> */}
            <img alt="copyright" className="mx-2" src={copyright} />
            {t("FooterText").replace(
              "{currentYear}",
              new Date().getFullYear().toString()
            )}
          </div>
          <span className="mx-2 d-none d-lg-block">{"|"}</span>
          <a
            className="py-2"
            href="https://whizpool.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="me-1 footerTerms">{t("FooterText1")}</span>
            <span className="footerTermsLinks">{t("FooterText1span")}</span>
          </a>
          <span className="mx-2 d-none d-lg-block">{"|"}</span>
          <div>
            <span
              onClick={() => {
                handlePage("/privacy-policy");
              }}
              className="footerTermsLinks pointer"
            >
              {t("FooterText2")}
            </span>
            <span className="mx-2">{"|"}</span>
            <span
              onClick={() => {
                handlePage("/terms");
              }}
              className="footerTermsLinks pointer"
            >
              {t("FooterText3")}
            </span>
            <span className="mx-2">{"|"}</span>
            <span
              onClick={() => {
                handlePage("/refund-policy");
              }}
              className="footerTermsLinks pointer"
            >
              {t("FooterText4")}
            </span>
          </div>
        </div>
      </Row>
    );
  }
};
export default Footer;
